




































import {
    Component,
    Vue,
    Prop
} from 'vue-property-decorator';
import getCode from '@components/getCode.vue';
@Component({
    components: {
        getCode
    }
})
export default class Renew extends Vue {
    @Prop() data!: object;
    private alertshow: boolean = false;
    private phoneinfo: object = {
        phone: '',
        code: ''
    }
    private account:string = ''
    private yz(){
        (this as any).$refs.phone.allverify().then((res:boolean)=>{

        })
    }
    private submit() {         
        (this as any).request('/user/applyViewAuthority.json', {
            data: {
                courseId: (this as any).data.id
            },
            method: 'post'
        }).then((res: any) => {
            this.alertshow = false;
            let msg = (this as any).data.title.includes('开通')?
                '开通权限' : '续费';
            (this as any).$alert({
                msg: `您的${msg}申请已成功提交，我们会尽快与您联系，请耐心等候。`,
                title: `${msg}申请已提交！`
            })
        })
    }
    private mounted() {
        if(this.$store.state.userinfo.role == 3) {
            // 学生
            this.account =  this.$store.state.userinfo.userName
        } else {
             this.account =  this.$store.state.userinfo.email
        }
    }
}
